import displayHyperlinks from "./displayHyperlinks";

export const columns = [
  {
    Header: 'Requirement',
    accessor: 'reqNumber',
    width: 120,
  },
  {
    Header: 'Details',
    accessor: 'details',
    Cell: ({ value }) => displayHyperlinks(value),
  },
];

export default {
  columns,
};



// WEBPACK FOOTER //
// ./src/components/grids/ItemDescInfoGrid/gridConfig.jsx